import 'jquery-validation';
import Utils from '../../util/utils';
const NewsLetterForm = {
    _jForm: $('.jsNewsletterForm'),
    init() {
        this.initValidations();
    },
    initValidations() {
        const me = this;
        if (this._jForm.length > 0) {
            var config = Utils.getValidationConfig({
                ignore: [],
                rules: {
                    email: {
                        required: true,
                        customemail: true,
                    },
                },
                messages: {
                    email: {
                        required: 'Please provide your Email address',
                        customemail: 'Please provide a valid Email address',
                    },

                },
                submitHandler: function() {
                    me.onFormSubmit();
                },
            });

            this._jForm.validate(config);
        }
    },

    onFormSubmit() {
        if (this._jForm.valid()) {
            var $form = this._jForm;
            var unindexed_array = $form.serializeArray();
            var indexed_array = {};
            jQuery.map(unindexed_array, function(n) {
                indexed_array[n['name']] = n['value'];
            });
            var formData = {};
            formData = indexed_array;
            // var skip_loader = $('.widget_newsletter').attr('data-showloader');
            // if(skip_loader == 'true'){
            //     skip_loader = true;
            // }
            // else{
            //     skip_loader = false;
            // }
            // formData.form_type = 'ask_us';
            Utils.sendRequest({
                // 'url': '/wp-json/contact-form-7/v1/contact-forms/2356/feedback',
                // 'data': formData,
                'url': '/wp-admin/admin-ajax.php',
                'data': {
                    'action': 'submitNewsletterForm',
                    'formData': formData,
                },
                'skipLoader' : true,
                'onDone': $.proxy(this._onSuccess, this),
            });


        }
        return false;
    },
    _onSuccess(response) {

      this._jForm[0].reset();

      Utils.notify({
          'message': response.message,
      });

    },

}
export default NewsLetterForm;



// WEBPACK FOOTER //
// ./scripts/modules/forms/newsletter-form.js